module.exports = __webpack_public_path__ + "static/media/20.Waving Hand 3.2fb3e264.gif";